<template>
  <div id="notifications-page">
    <vs-table
      ref="table"
      :sst="true"
      :max-items="100"
      @sort="handleSort"
      @selected="handleSelected"
      :data="noticesData"
      :total="paginationPageSize"
      class="card-table"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer" v-if="noticesDataCount">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2">
              {{ (currentPage * paginationPageSize - (paginationPageSize - 1)) | persian_digits }}
              {{ $t('forms.to') }}
              {{
                noticesDataCount - currentPage * paginationPageSize > 0
                  ? currentPage * paginationPageSize
                  : noticesDataCount | persian_digits
              }}
              {{ $t('forms.from') }} {{ noticesDataCount | persian_digits }}
            </span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="paginationSetPageSize(5)">
              <span>{{ 5 | persian_digits }}</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="paginationSetPageSize(10)">
              <span>{{ 10 | persian_digits }}</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="paginationSetPageSize(50)">
              <span>{{ 50 | persian_digits }}</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="paginationSetPageSize(100)">
              <span>{{ 100 | persian_digits }}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
        <!-- PAGINATION -->
        <div>
          <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="title">{{ $t('notices.notice') }}</vs-th>
        <vs-th sort-key="created_at">{{ $t('entity.created_at') }}</vs-th>
        <vs-th sort-key="state">{{ $t('forms.actions') }}</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody id="table-body" v-if="data.length">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <div class="flex items-start">
                <feather-icon
                  :icon="tr.icon"
                  :svgClasses="[`text-${tr.category}`, 'stroke-current mr-1 h-6 w-6']"
                ></feather-icon>
                <div class="mx-2">
                  <span class="font-medium block notification-title" :class="[`text-${tr.category}`]">
                    {{ tr.title }}
                  </span>
                  <small>{{ tr.description }}</small>
                </div>
              </div>
            </vs-td>
            <vs-td>
              {{ tr.created_at | datetime }}
            </vs-td>
            <vs-td class="whitespace-no-wrap">
              <div v-if="tr.state === 'unseen'">
                <feather-icon icon="EyeIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" />
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <!-- PAGINATION -->
    <div>
      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Notifications',
  data() {
    return {
      // Filter Options
      query: {},

      //Sort
      sort: {},
      currentPage: 1
    }
  },
  watch: {
    currentPage(val) {
      this.$store.commit('notices/SET_NOTICES_SKIP', (val - 1) * this.paginationPageSize)
      this.updateTable()
    }
  },
  computed: {
    noticesDataCount() {
      return this.$store.state.notices.noticesCount
    },
    noticesData() {
      return this.$store.state.notices.notices
    },
    paginationPageSize() {
      return this.$store.state.notices.limit
    },
    totalPages() {
      return this.$store.getters['notices/totalPages']
    }
  },
  methods: {
    handleSelected(notice) {
      this.seeNotification(notice)
      if (notice.source) this.$router.push(notice.source)
    },
    setQuery() {
      this.$store.commit('notices/SET_NOTICES_QUERY', {
        ...this.query,
        to: this.$store.state.AppActiveUser.id
      })
      this.currentPage = 1
      this.updateTable()
    },
    updateTable() {
      this.$vs.loading({
        scale: 0.6
      })
      this.$store.dispatch('notices/fetchNotices').then(() => {
        this.$vs.loading.close()
      })
      this.$store.dispatch('notices/countNotices')
    },
    paginationSetPageSize(items) {
      this.$store.commit('notices/SET_NOTICES_LIMIT', items)
      this.updateTable()
    },
    handleSort(col, active) {
      if (col === null) return
      if (active !== null) {
        this.sort[col] = active === 'asc' ? 1 : -1
      } else {
        this.sort['state'] = 1
      }
      this.query['sort'] = this.sort
      this.setQuery()
    },
    seeNotification(notification) {
      if (notification.state !== 'visited')
        this.$store.dispatch('notices/editNotice', { id: notification.id, data: { state: 'visited' } })
    }
  },
  created() {
    this.query['sort'] = this.sort
    this.sort['state'] = 1
    this.sort['created_at'] = -1
    this.setQuery()
  }
}
</script>

<style lang="scss">
#notifications-page {
}
</style>
